import { E_OFFICE_PREFIX_URL } from '../../e-office-layout/constants/config.e-office-layout'

export const QUAN_LY_GIAO_VIEC_SHORT_PREFIX_URL = '/quan-ly-giao-viec'
export const QUAN_LY_GIAO_VIEC_PREFIX_URL = `${E_OFFICE_PREFIX_URL}${QUAN_LY_GIAO_VIEC_SHORT_PREFIX_URL}`

export const defaultOrderIndex = 16384
